export const DefaultBlankText = '-';

export default DefaultBlankText;
